import React from 'react'
import { useGetStopLinesMutation, useGetStopLineTimesMutation, useGetStopRealLineTimesMutation } from '../../../../../../../redux/login/explore/stopsService';
import { VM } from '../../../../../../../viewmodel/VM';
import { Apis } from '../../../../../../../domain/Apis';
import { useLanguage } from '../../../../../../context/languageContext';
import { agencyInformation } from '../../../../../../../redux/slices/agencySlice';
import { useSelector } from 'react-redux';
import { ILine } from '../../../../../../../types/LineInterfaces';
import { markersInformation } from '../../../../../../../redux/slices/markersSlice';

export default function useStopParentHook() {
  const [getStopLines] = useGetStopLinesMutation();
  const [GetStopTimesTheory] = useGetStopLineTimesMutation();
  const [GetStopRealTimes] = useGetStopRealLineTimesMutation();
  const language = useLanguage();
  const dataOrigin = useSelector(agencyInformation).dataOrigin;
  const allStops = useSelector(markersInformation).stops;

  async function obtainLinesInfo(stopId: number, stopSonsIds: Array<number>, agencyOriginId: number, setLines: (value: any) => void, setType: Function, setIconType: Function, setLinesBySonOfParent: Function) {
    
    if (!VM.dataOrigin?.data?.length) {
            let res = dataOrigin;
            let foundData: any = res.find((element: any) => element.id === agencyOriginId);
            if (!foundData) {
            } else {
              if (foundData?.groupTxt) {
                setType(foundData?.groupTxt);
                let iconTypeFound = await VM.icons.getIcon(foundData?.operatorIconid);
                !iconTypeFound?.error && setIconType(iconTypeFound);
              } else {
                let typeAg = await (Apis as any).agency?.getAgency(language, foundData?.agencyId);
                !typeAg?.error && setType(typeAg);
                let iconTypeFound = await VM.icons.getIcon(foundData?.agencyId, 'agency');
                !iconTypeFound?.error && setIconType(iconTypeFound);
              }
            }
          } else {
            setIconType(
              await VM.icons.getIcon(VM.dataOrigin?.data[agencyOriginId]?.agencyId, 'agency')
            );
            setType(
              await (Apis as any).agency?.getAgency(language, (dataOrigin[agencyOriginId] as any)?.agencyId)
            );
    }

    const allResultsLines = await Promise.all(stopSonsIds.map(async (id) => {
        const result: any = await getStopLines({id: id});
        if (result?.data) {
            return result?.data;
        } else {
            return [];
        }
    }));
    //obtener todas las lineas de la estación a partir de los hijos
    const resultedtLines: Array<ILine> = [];
    allResultsLines.flat().forEach((line) => {
        if (!resultedtLines.find((element) => element.id === line.id)) {
            resultedtLines.push(line);
        }
    });
    setLines(resultedtLines);
    
    //obtener las lineas de la estación en funcion del hijo de manera organizada {id: hijo, lineas: lineas del hijo}
    const organizedLinesBySon: Array<any> = [];
    allResultsLines.forEach((stopLines: Array<ILine>, index: number) => {
        organizedLinesBySon.push({stopId: stopSonsIds[index], lines: stopLines});
    });
    setLinesBySonOfParent(organizedLinesBySon);

    //vamos a parsear los datos de las lineas de la estacion para 
    //que las lineas tengan el identificador de las paradas

    let copyResultedLines: Array<any> = JSON.parse(JSON.stringify(resultedtLines));
    organizedLinesBySon.forEach((organized: any) => {
        organized?.lines?.forEach((line: ILine) => {
            const foundLine = copyResultedLines.findIndex((fLine) => fLine.id === line.id);
            if (foundLine !== -1) {
                if (copyResultedLines[foundLine]?.sons) {
                    const copySons = [...copyResultedLines[foundLine]?.sons];
                    copySons.push(organized.stopId);
                    copyResultedLines[foundLine] = {...copyResultedLines[foundLine], ...{sons: copySons}};
                } else {
                    copyResultedLines[foundLine].sons = [organized.stopId];
                }
            }
        });
    });

    return copyResultedLines;
  }

  async function obtainTimesOfSons(stopSonsIds: Array<number>, date: string, setLinesTimes: Function, setLinesRealTimes: Function) {
    const allResultsLines = Promise.all(stopSonsIds.map(async (id) => {
        const resultTime: any = await GetStopTimesTheory({id: id, locale: language, date: date});
      
        if (resultTime?.data) {
            return resultTime?.data;
        } else {
            return [];
        }
    }));

    setLinesTimes((await allResultsLines).flat());

    const allResultsLinesTimeReals = Promise.all(stopSonsIds.map(async (id) => {
        const resultReal: any = await GetStopRealTimes({ locale: language, id: id });
      
        if (resultReal?.data) {
            return resultReal?.data;
        } else {
            return [];
        }
    }));
    setLinesRealTimes((await allResultsLinesTimeReals).flat());
  }

  function obtainParentStopSons(parentId: number) {
    return allStops.filter((stop: any) => stop?.stopParentId === parentId);
  }

  return {
    obtainLinesInfo,
    obtainTimesOfSons,
    obtainParentStopSons
  };
}
